// src/utils/apiErrors.js
export function toFormErrors(err) {
  const data = err?.response?.data;
  if (!data || typeof data !== "object") return { __all__: "Unexpected error" };
  if (data.error) return { __all__: String(data.error) };
  if (data.detail) return { __all__: String(data.detail) };

  const out = {};
  Object.entries(data).forEach(([k, v]) => {
    out[k] = Array.isArray(v) ? v.join(" ") : String(v);
  });
  return out;
}
